import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Stack as StackMUI } from '@mui/material';

export const Price = styled('h1')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 64px;
  line-height: 100%;
  text-edge: cap;
  color: ${({ theme }) => theme.palette.text.dark};
  padding: 0;
  margin: 0;
`;

export const SubPrice = styled('h1')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 50%;
  text-edge: cap;
  color: ${({ theme }) => theme.palette.text.dark};
  padding-top: 10px;
`;

export const Period = styled('h1')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.25%;

  text-edge: cap;
  color: ${({ theme }) => theme.palette.text.main};
  padding-top: 10px;
  display: inline-block;
`;
export const PeriodDivider = styled('h1')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 23px;
  line-height: 16.25%;
  leading-trim: both;
  text-edge: cap;
  color: ${({ theme }) => theme.palette.text.main};
  padding-top: 10px;
  display: inline-block;
`;

export const Stack = styled(StackMUI)`
  margin-bottom: 10px;
`;
